export enum MobileIdentificationStatusType {
    Approved = 1,
    Denied = 2,
    ExtendedReview = 3,
    Pending = 4,
    Active = 5,
    Cancelled = 6,
    Suspended = 7,
    Unlinked = 8
}
